import { http } from '@pendo/http';

export function findAccounts (searchText, accountIds, abortSignal) {
    const url = `/api/s/_SID_/account/find?search=${encodeURIComponent(searchText)}&accountIds=${encodeURIComponent(
        accountIds.join(','),
    )}`;

    const config = abortSignal ? { signal: abortSignal } : {};

    return http
        .get(url, config)
        .then((response) => response.data)
        .catch((err) => {
            throw err;
        });
}

export function findVisitors (searchText, pendoAccountId, crmAccountId, crmLookup, abortSignal) {
    let url = `/api/s/_SID_/visitor/find?search=${encodeURIComponent(searchText)}&crmLookup=${crmLookup}`;
    if (pendoAccountId) {
        url += `&pendoAccountId=${encodeURIComponent(pendoAccountId)}`;
    }
    if (crmAccountId) {
        url += `&crmAccountId=${encodeURIComponent(crmAccountId)}`;
    }

    const config = abortSignal ? { signal: abortSignal } : {};

    return http
        .get(url, config)
        .then((response) => response.data)
        .catch((err) => {
            throw err;
        });
}
